import { LabeledSwitch } from '@components/switch';

import { useUpdateCompanyInfo } from 'api/companies/hooks';
import { useStore } from 'models/Provider';

type DeadlineSettingsProps = {
  isDeadlineRequired: boolean;
};

export const DeadlineSettings = ({ isDeadlineRequired }: DeadlineSettingsProps) => {
  const { t } = useStore();
  const submit = useUpdateCompanyInfo({
    successMessage: t('company.settings.root.updateSuccess'),
    errorMessage: t('company.settings.root.updateError'),
  });

  return (
    <LabeledSwitch
      label={t('company.settings.root.deadline.required')}
      onText={t('company.settings.root.deadline.enabled')}
      offText={t('company.settings.root.deadline.disabled')}
      defaultValue={isDeadlineRequired}
      onChange={(value) => submit.mutate({ isDeadlineRequired: value })}
    />
  );
};
